import { ChevronLeft, ChevronRight } from 'lucide-react';

type ScreensPaginationProps = {
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
};

export function ScreensPagination({
  page,
  totalPages,
  onPageChange,
}: ScreensPaginationProps) {
  if (totalPages <= 1) return null;

  return (
    <div className="mt-1 flex items-center justify-between gap-3 border-t border-[#EEF0F5] pt-3">
      <button
        type="button"
        disabled={page <= 1}
        onClick={() => onPageChange(Math.max(1, page - 1))}
        className="inline-flex items-center gap-1 rounded-lg border border-[#E6E8EF] bg-white px-2.5 py-1.5 text-[12px] font-semibold text-[#1F2433] transition hover:bg-[#F8F9FB] disabled:cursor-not-allowed disabled:opacity-40 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--dash-brand)]"
      >
        <ChevronLeft className="h-3.5 w-3.5" />
        Previous
      </button>

      <span className="text-[12px] text-[#6B7289]">
        Page <span className="font-semibold text-[#1F2433]">{page}</span> of{' '}
        <span className="font-semibold text-[#1F2433]">{totalPages}</span>
      </span>

      <button
        type="button"
        disabled={page >= totalPages}
        onClick={() => onPageChange(page + 1)}
        className="inline-flex items-center gap-1 rounded-lg border border-[#E6E8EF] bg-white px-2.5 py-1.5 text-[12px] font-semibold text-[#1F2433] transition hover:bg-[#F8F9FB] disabled:cursor-not-allowed disabled:opacity-40 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--dash-brand)]"
      >
        Next
        <ChevronRight className="h-3.5 w-3.5" />
      </button>
    </div>
  );
}
